import { __decorate, __metadata } from "tslib";
import { dispatchEvent, subscribe } from '@1inch-community/core/lit-utils';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { fromEvent, tap } from 'rxjs';
import '../../icon';
import { cardCloseOverlayStyle } from './card-close-overlay.style';
let CardCloseOverlayElement = class CardCloseOverlayElement extends LitElement {
    static { this.tagName = 'inch-card-close-overlay'; }
    static { this.styles = cardCloseOverlayStyle; }
    constructor() {
        super();
        this.slot = 'close-overlay';
    }
    firstUpdated() {
        subscribe(this, [
            fromEvent(this, 'click').pipe(tap((event) => dispatchEvent(this, 'closeCard', null, event))),
        ], { requestUpdate: false });
    }
    render() {
        return html ` <inch-icon icon="hideSidebar24"></inch-icon> `;
    }
};
CardCloseOverlayElement = __decorate([
    customElement(CardCloseOverlayElement.tagName),
    __metadata("design:paramtypes", [])
], CardCloseOverlayElement);
export { CardCloseOverlayElement };
//# sourceMappingURL=card-close-overlay.element.js.map